import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { LessonEditForGrade } from './LessonEditForGrade'
import { getIdData } from '../../lib/studentinfo'

const StudentLessonEditForGrade = () => {
	const { status, studentId: studentIdParam } = useParams()
	const { user } = useAuth()

	const isInstructorView = user?.role === 'Instructor'
	const studentId = isInstructorView ? studentIdParam : user?.id
	const [studentClass, setStudentClass] = useState(isInstructorView ? null : user?.class ?? null)
	const [loading, setLoading] = useState(isInstructorView)

	useEffect(() => {
		let isMounted = true

		const fetchStudentClass = async () => {
			try {
				setLoading(true)
				const studentInfo = await getIdData(studentId)
				if (isMounted && studentInfo && studentInfo.length > 0) {
					setStudentClass(studentInfo[0]?.class ?? null)
				}
			} catch (error) {
				console.error('Error fetching student class information:', error)
			} finally {
				if (isMounted) {
					setLoading(false)
				}
			}
		}

		if (isInstructorView && studentId) {
			fetchStudentClass()
		} else {
			setLoading(false)
		}

		return () => {
			isMounted = false
		}
	}, [isInstructorView, studentId])

	if (!studentId) {
		return (
			<StudentTopMenuLayout activeMenu="Lessons" pageName="LessonsEdit" showPageNotes={false}>
				<div className="alert alert-warning" role="alert">
					Student information is unavailable.
				</div>
			</StudentTopMenuLayout>
		)
	}

	return (
		<StudentTopMenuLayout activeMenu="Lessons" pageName="LessonsEdit" showPageNotes={false}>
			{loading ? (
				<div className="card mb-4 shadow-sm">
					<div className="card-body text-center">
						<div className="spinner-border" role="status">
							<span className="visually-hidden">Loading...</span>
						</div>
						<p className="mt-2 mb-0">Loading course information...</p>
					</div>
				</div>
			) : studentClass ? (
				<LessonEditForGrade status={status} studentId={studentId} studentClass={studentClass} />
			) : (
				<div className="alert alert-warning" role="alert">
					Unable to determine the student's class information.
				</div>
			)}
		</StudentTopMenuLayout>
	)
}

export { StudentLessonEditForGrade }
